import {t} from "@lingui/core/macro";
import memoize from "lodash.memoize";

export enum SearchableContentKinds {
    Article = "Article",
    Exercise = "Exercise",
    Video = "Video",
    Topic = "Topic",
    AIActivity = "AIGuideActivity",
    Course = "Course",
    Unit = "Unit",
    Lesson = "Lesson",
}

export type FilterLabel = {
    id: string;
    label: string;
    // NOTE: Some filter values need to be present for search to work, but we don't
    // want to display them to the user. Currently AI Activities are the only
    // type of this: They're included by selecting the content type filter, but
    // they're also a domain. We just don't want to show the domain checkbox
    // too, since it makes no sense for users to see AI Activities checkbox
    // twice, once in content types and once in domains.
    isVisible?: boolean;
};

export const getValidContentKinds = memoize((): FilterLabel[] => [
    {
        id: SearchableContentKinds.Article,
        label: t`Article`,
    },
    {
        id: SearchableContentKinds.Exercise,
        label: t`Exercise`,
    },
    {
        id: SearchableContentKinds.Video,
        label: t`Video`,
    },
    {
        id: SearchableContentKinds.Topic,
        label: t`Courses, Units, and Lessons`,
    },
    {
        id: SearchableContentKinds.AIActivity,
        label: t`AI Activities`,
    },
]);

export const getValidTopicAncestors = memoize((): FilterLabel[] => [
    {
        id: "math",
        label: t`Math`,
        isVisible: true,
    },
    {
        id: "science",
        label: t`Science`,
        isVisible: true,
    },
    {
        id: "economics-finance-domain",
        label: t`Economics and finance`,
        isVisible: true,
    },
    {
        id: "humanities",
        label: t`Arts and humanities`,
        isVisible: true,
    },
    {
        id: "computing",
        label: t`Computing`,
        isVisible: true,
    },
    {
        id: "test-prep",
        label: t`Test prep`,
        isVisible: true,
    },
    {
        id: "partner-content",
        label: t`Partner content`,
        isVisible: true,
    },
    {
        id: "college-careers-more",
        label: t`Life skills`,
        isVisible: true,
    },
    {
        id: "khan-for-educators",
        label: t`Khan for Educators`,
        isVisible: true,
    },
    {
        id: "ai-activities",
        label: t`AI Activities`,
        // AI Activities course is a special case that is not intended to be
        // seen in the content library, but is required in order to house
        // AIGuideActivity kind content items
        isVisible: false,
    },
]);
